import type { IconProps } from '../types/IconProps.ts';
export const Send: IconProps = {
    name: 'Send',
    children: [
        `<path d="M21.7 12.48 2.77 21a.5.5 0 0 1-.7-.57l2.05-8.29v-.24L2.09 3.62a.5.5 0 0 1 .69-.58l18.91 8.53c.4.17.4.73 0 .9ZM4.16 12.02h17.39" />`,
    ]
};